import script from "./findColorTab.vue?vue&type=script&setup=true&lang=js"
export * from "./findColorTab.vue?vue&type=script&setup=true&lang=js"

import "./findColorTab.vue?vue&type=style&index=0&id=1549104f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1549104f"]])

export default __exports__